var map = {
	"./542628/05705B17EA9710EC1.eot": 2,
	"./542628/5BDBE559C80C7A809.eot": 3,
	"./542628/86ACBB57A4298CDE5.eot": 4,
	"./542628/BCC14573D90CCBEE4.eot": 5,
	"./GT-America-Bold.eot": 6,
	"./GT-America-Bold.woff": 7,
	"./GT-America-Regular-Italic.eot": 8,
	"./GT-America-Regular-Italic.woff": 9,
	"./GT-America-Regular.eot": 10,
	"./GT-America-Regular.woff": 11,
	"./TiemposHeadlineWeb-Black.eot": 12,
	"./TiemposHeadlineWeb-Black.woff": 13,
	"./TiemposHeadlineWeb-Black.woff2": 14,
	"./TiemposHeadlineWeb-Light.eot": 15,
	"./TiemposHeadlineWeb-Light.woff": 16,
	"./TiemposHeadlineWeb-Light.woff2": 17,
	"./TiemposHeadlineWeb-LightItalic.eot": 18,
	"./TiemposHeadlineWeb-LightItalic.woff": 19,
	"./TiemposHeadlineWeb-LightItalic.woff2": 20,
	"./TiemposTextWeb-Bold.eot": 21,
	"./TiemposTextWeb-Bold.woff": 22,
	"./TiemposTextWeb-Bold.woff2": 23,
	"./TiemposTextWeb-Regular.eot": 24,
	"./TiemposTextWeb-Regular.woff": 25,
	"./TiemposTextWeb-Regular.woff2": 26,
	"./TiemposTextWeb-RegularItalic.eot": 27,
	"./TiemposTextWeb-RegularItalic.woff": 28,
	"./TiemposTextWeb-RegularItalic.woff2": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;